import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../SuccessStories/SuccessStories.css";
import aws_success from "../../assets/images/aws_success.png";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

const SuccessStories = () => {
  return (
    <div>
      <Helmet>
        <title>Success Stories | Idexcel</title>
        <meta
          content="success stories, aws partner story, client success story"
          name="keywords"
        />
        <meta
          content="Read our latest success story to learn how Idexcel helped clients transform their businesses and stay at the top of our ever-changing industry."
          name="description"
        />
      </Helmet>
      <motion.div
        className="Productright"
        initial={{ opacity: 0, x: 50 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <Container fluid className="success-banner-container p-0">
          <section className="success-banner-section"></section>
        </Container>
      </motion.div>

      <section className="success-stories-section ">
        <Container className="my-5 px-xl-5" style={{ textAlign: "justify" }}>
          <h2 className="text-center mb-4 section-title">
            <span className="textgrad"> Success</span> Stories
          </h2>
          <h4
            className="text-black mb-5 text-left"
            style={{ lineHeight: "unset" }}
          >
            <span className="fw-semibold"> AWS Partner Story:</span> Idexcel
            Manages and Maintains Cync Software's flagship product "Cync
            Application Suite" on Amazon Web Services Infrastructure
          </h4>
          <section>
            <h4 className="fw-semibold">About Cync Software</h4>
            <p className="pt-2 m-0  mb-5">
              <a
                style={{ padding: "inherit" }}
                className="text-danger textDecoration"
                target="_blank"
                href="https://www.ndsapps.com/"
              >
                NDS Systems
              </a>
              , based in Tampa, Florida, understands that the software market is
              in a constant state of flux. These ever-changing market conditions
              present a unique set of challenges for any software provider. NDS
              Systems’ offerings include NDS ERP and{" "}
              <a
                className="text-danger textDecoration"
                target="_blank"
                href="https://www.cyncsoftware.com/"
              >
                Cync Software
              </a>
              .
            </p>
          </section>
          <section className="mt-3">
            <h4 className="fw-semibold">
              Innovating in the Commercial Lending Market
            </h4>
            <p className="pt-2 m-0 ">
              NDS Systems has a vision to automate the exchange of information
              between borrowers and lenders in the commercial lending market, an
              industry that is complex and highly controlled.
            </p>
            <p className="pt-2 my-2">
              "Our flagship product, Cync Application Suite, provides a diverse
              collection of financing-software solutions that cover a vast range
              of asset-based lending, accounts-receivable financing, factoring,
              and related credit services,” explains Jennifer Ballard, Director
              of client services for Cync Software. “By streamlining,
              standardizing, and automating the collection and analysis of
              borrowers’ financial information, the Cync Application Suite
              provides a complete solution for industry organizations—from
              commercial finance companies and national and regional banks to
              A/R financing companies—to track and monitor all aspects of their
              commercial lending portfolio."
            </p>
            <p className="pt-2 m-0  my-2 mb-5">
              She continues, "Cync has focused its efforts on increasing
              productivity, reducing labor costs and mitigating risk. Asset
              Based Lending is very complex and requires a lot of manpower to
              monitor and manage the risks associated with these loans. In a
              recent client survey, Cync users have reported up to 75% increased
              productivity, 35% reduction in labor costs and 100% reported that
              Cync assists them in making better credit decisions for their
              companies and clients alike."
            </p>
          </section>
          <section className="mt-3">
            <h4 className="fw-semibold">Why AWS</h4>
            <p className="pt-2 m-0 ">
              When NDS Systems first started developing the Cync Software
              application, they hosted it themselves. One of the challenges of
              being new to the industry is managing costs so that the company
              can continue to add features and eventually become a core banking
              application that everyone uses.
            </p>
            <p className="pt-2 m-0  my-2">
              "Some of our competitors are in the cloud, but most of them stick
              with the private cloud and have all of the costs and
              responsibilities associated with that,” says Ballard. “We think
              AWS is a smarter choice because of its high availability,
              scalability, reliability, and security compliance."
            </p>
            <p className="pt-2 m-0  my-2">
              Scalability is particularly helpful for Cync Software’s growth. "I
              don't have to know how big a customer's data is going to get or
              how many file uploads they're going to have in a day," says
              Ballard. "With AWS, there are no limits. That was huge for us
              because continuously monitoring that—to know what volume to
              expect—is really challenging."
            </p>
            <p className="pt-2 m-0   my-2 mb-5">
              Ballard knew from the beginning that they would need a partner to
              help with the move. "Our core competency is selling and supporting
              Cync Software; we needed a technology partner familiar with AWS
              implementations to help us." The company turned to long-time APN
              partner Idexcel in the early stages of product development.
            </p>
          </section>
          <section className="mt-3">
            <h3 className="mt-3">
              Scalable, Available and Reliable—All in the Cloud
            </h3>
            <p className="pt-2 m-0">
              Idexcel began working with Cync Software in 2011. "The start of
              the relationship was just moving the infrastructure into AWS,"
              says Jed Tonelson, Director cloud sales for Idexcel. "We
              understood that their product, as a SaaS application, had to
              maintain data security and data integrity in addition to being
              highly scalable and available."
            </p>
            <p className="pt-2 m-0 my-2 mb-5">
              Cync Software is a highly scalable and highly available web
              application running in the AWS Cloud. It uses{" "}
              <a
                href="https://aws.amazon.com/waf/"
                target="_blank"
                className="text-danger textDecoration"
              >
                AWS Web Application Firewall{" "}
              </a>
              (AWS WAF) to secure incoming traffic, with web and app servers
              hosted behind internal{" "}
              <a
                href="https://aws.amazon.com/elasticloadbalancing/"
                target="_blank"
                className="text-danger textDecoration"
              >
                Elastic Load Balancers
              </a>{" "}
              (ELBs) in private subnets. Internal ELBs distribute traffic to the
              app servers and autoscale the server on demand. The application
              uses{" "}
              <a
                href="https://aws.amazon.com/rds/"
                target="_blank"
                className="text-danger textDecoration"
              >
                {" "}
                Amazon Relational Database Service{" "}
              </a>
              (Amazon RDS) for private data storage, while static files are
              stored in private{" "}
              <a
                href="https://aws.amazon.com/s3/"
                target="_blank"
                className="text-danger textDecoration"
              >
                Amazon Simple Storage Service{" "}
              </a>
              (Amazon S3) buckets and published using{" "}
              <a
                href="https://aws.amazon.com/cloudfront/"
                target="_blank"
                className="text-danger textDecoration"
              >
                Amazon CloudFront
              </a>
              .
            </p>
          </section>
          <section className="success-stories-img-text mt-2">
            <h4 className="fw-semibold">Cync Software IT architecture</h4>
            <Row className="m-0 p-0 px-0 px-lg-3">
              <Col className="m-0 p-0 img-wrap-stories pe-md-5">
                <img src={aws_success} className="success-architecture-img" />
              </Col>
            </Row>
            <p className="pt-2 m-0 mt-4">
              In addition, some features use microservices, such as Amazon's API
              Gateway, Lambda, and EC2 Container Service (ECS). To improve
              performance, the system uses Amazon ElastiCache, while AWS
              CloudTrail maintains application and infrastructure logs, and
              Amazon CloudWatch and Elasticsearch Service (Amazon ES) provide
              monitoring and alerts.
            </p>
            <p className="pt-2 m-0 my-2 mb-5">
              Ballard and her team are working hard to round out the Cync
              Software offerings by adding functionality that provides more of
              what lenders need. "Our software is new to the market, so we don’t
              yet have all the features and functionality that our competitors
              do," says Ballard. “Using AWS and partnering with Idexcel lets us
              focus on the features that we want to add—credit services,
              financial spreading, and additional reporting."
            </p>
          </section>
          <section className="mt-3">
            <h4 className="fw-semibold">The AWS Partner Network Advantage</h4>
            <p className="pt-2 m-0  mt-2">
              "Idexcel has been achieving excellence by delivering high-quality
              custom application development services, innovative testing
              solutions, and competitively priced IT staffing services to
              clients for nearly two decades," explains Tonelson.
            </p>
            <p className="pt-2 m-0 my-2">
              The company's AWS experience and certification as an APN Partner
              made them a great choice for the Cync Software's migration to the
              cloud. "Of course, we really wanted to find someone who already
              had AWS experience, but we also wanted a development house to help
              us continue adding features."
            </p>
            <p className="pt-2 m-0 my-2">
              The Idexcel team worked to improve and modernize the application
              as they set it up in AWS. Ballard notes, "As development
              progressed, we engaged in some different projects to see how well
              we could work together in that respect. We added a person on-site
              from their organization and went from there."
            </p>
            <p className="pt-2 m-0 my-2 mb-5">
              Now Cync has a dedicated Idexcel team. “We had several software
              developers in our Tampa location, but when we entered into a
              partnership with Idexcel, it gave us access to a large offshore
              development team that not only provides additional development but
              24 hour support for our clients as well,” explains Ballard. "I get
              work done during U.S. hours with our staff and while we're
              sleeping, their India office is working on deployments, changes to
              the application, security suggestions, and other major tasks.
              Because of this partnership, Cync can now provide round-the-clock
              support and it’s a win-win for everybody." (Know more about our
              <a
                href="https://aws.amazon.com/partners/success/cync-software/"
                target="_blank"
                className="text-danger textDecoration"
              >
                {" "}
                AWS Partner Story
              </a>
              )
            </p>
          </section>
          <section className="mt-3 mb-5">
            <h4 className="fw-semibold"> About Idexcel</h4>
            <p className="pt-2 m-0 mt-2 mb-4">
              For more information about how Idexcel can help your company build
              and manage your AWS environment, see Idexcels' listing in the
              <a
                href="https://aws.amazon.com/partners/find/partnerdetails/?n=Idexcel&id=001E000000e1EYNIA2"
                target="_blank"
                className="text-danger textDecoration"
              >
                {" "}
                AWS Partner Directory
              </a>
              .
            </p>
          </section>
        </Container>
      </section>
      <Container fluid className="bg-black">
        {/* <Row className="p-0 m-0 bg-black content px-xl-5 pt-xl-5 pb-5"> */}
        <Container className="px-3 px-xl-2 px-lg-0">
          <section className="px-0 px-lg-5 pt-1 pb-3">
            <h2 className=" mb-4 section-title">
              <span className="textgrad"> Testimonial</span>
            </h2>
            <div className="bg-white px-4 py-4">
              <p className="pb-3 pb-md-4 fs-5 Testmonial-content">
                "Our goal is to become a full-featured core banking application
                available in the cloud. With AWS and technology partner Idexcel,
                we’re on our way."
              </p>
              <p className="mb-4">
                <span className="fw-semibold">Jennifer Ballard </span>- Director of Client Services, Cync
                Software/NDS Systems LC
              </p>
            </div>
          </section>
        </Container>
        {/* </Row> */}
      </Container>
    </div>
  );
};

export default SuccessStories;
